import gql from 'graphql-tag';
import { timeSeriesFragment } from '@app/pages/cmms/components/assets/asset-time-series/misc/asset-time-series-queries';
import { TypedDocumentNode } from '@apollo/client/core';
import {
	TimeSeriesChartsObjectType,
	TimeSeriesSettings,
} from '@app/pages/cmms/components/assets/asset-time-series/misc/interfaces';

export const deleteAssetTimeseries = gql`
	mutation deleteAssetTimeseries($ids: [UUID]!) {
		deleteAssetTimeseries(ids: $ids) {
			success
		}
	}
`;

export const editAssetTimeseries = gql`
	mutation editAssetTimeseries($pk: UUID!, $value: Decimal!, $date: DateTime) {
		editAssetTimeseries(pk: $pk, value: $value, date: $date) {
			success
			timeseries {
				...TimeSeriesFragment
			}
		}
	}
	${timeSeriesFragment}
`;

export const createAssetTimeseries = gql`
	mutation createAssetTimeseries($timeSeries: [CreateAssetTimeSeriesInput]) {
		createAssetTimeseries(timeSeries: $timeSeries) {
			success
			timeseries {
				...TimeSeriesFragment
			}
		}
	}
	${timeSeriesFragment}
`;

export const createOrEditChartSection: TypedDocumentNode<
	{
		createOrUpdateAssetTimeseriesChart: {
			chart: TimeSeriesChartsObjectType;
			settings: TimeSeriesSettings;
			success: boolean;
		};
	},
	{
		assetId?: string;
		name?: string;
		chartId?: string;
		description?: string;
		unit?: string;
		benchmark?: number;
		lowerBound?: number;
		upperBound?: number;
	}
> = gql`
	mutation createOrEditChartSection(
		$assetId: UUID
		$name: String
		$chartId: UUID
		$description: String
		$unit: String
		$benchmark: Float
		$lowerBound: Float
		$upperBound: Float
	) {
		createOrUpdateAssetTimeseriesChart(
			assetId: $assetId
			chartName: $name
			chartId: $chartId
			unit: $unit
			benchmark: $benchmark
			lowerBound: $lowerBound
			upperBound: $upperBound
			description: $description
		) {
			success
			chart {
				pk
				name
				description
				timeSeries {
					edges {
						node {
							...TimeSeriesFragment
						}
					}
				}
			}
			settings {
				benchmark
				lowerBound
				unit
				upperBound
			}
		}
	}
	${timeSeriesFragment}
`;

export const deleteChartSection = gql`
	mutation deleteChartSection($chartId: UUID!) {
		deleteAssetTimeseriesChart(chartId: $chartId) {
			success
		}
	}
`;
